import { __ } from '@wordpress/i18n';

export const VENDOR_QUOTES_STORE = 'dokan/vendor-quotes';

export const API_ENDPOINTS = {
    LIST: '/dokan/v1/request-for-quote/vendor',
    DETAILS: '/dokan/v1/request-for-quote/vendor/:id',
    APPROVE: '/dokan/v1/request-for-quote/vendor/:id/approve',
    REJECT: '/dokan/v1/request-for-quote/vendor/:id/reject',
    CONVERT: '/dokan/v1/request-for-quote/vendor/:id/convert',
    TRASH: '/dokan/v1/request-for-quote/vendor/:id/trash',
    REOPEN: '/dokan/v1/request-for-quote/vendor/:id/reopen',
    BATCH: '/dokan/v1/request-for-quote/vendor/batch',
};

export const ACTION_TYPES = {
    SET_QUOTES: 'SET_QUOTES',
    SET_QUOTE: 'SET_QUOTE',
    SET_HEADERS: 'SET_HEADERS',
    SET_LOADING: 'SET_LOADING',
    SET_PARENT_QUOTES: 'SET_PARENT_QUOTES',
    REMOVE_QUOTE: 'REMOVE_QUOTE',
    SET_ERROR: 'SET_ERROR',
} as const;

export const QUOTE_STATUS = {
    PENDING: 'pending',
    UPDATED: 'updated',
    APPROVE: 'approve',
    CONVERTED: 'converted',
    REJECT: 'reject',
    ACCEPTED: 'accepted',
    EXPIRED: 'expired',
    CANCEL: 'cancel',
    TRASH: 'trash',
} as const;

export const STATUS_LABELS = {
    [ QUOTE_STATUS.PENDING ]: __( 'Pending', 'dokan' ),
    [ QUOTE_STATUS.UPDATED ]: __( 'Updated', 'dokan' ),
    [ QUOTE_STATUS.APPROVE ]: __( 'Approved', 'dokan' ),
    [ QUOTE_STATUS.CONVERTED ]: __( 'Converted', 'dokan' ),
    [ QUOTE_STATUS.REJECT ]: __( 'Rejected', 'dokan' ),
    [ QUOTE_STATUS.ACCEPTED ]: __( 'Accepted', 'dokan' ),
    [ QUOTE_STATUS.EXPIRED ]: __( 'Expired', 'dokan' ),
    [ QUOTE_STATUS.CANCEL ]: __( 'Cancelled', 'dokan' ),
    [ QUOTE_STATUS.TRASH ]: __( 'Trash', 'dokan' ),
} as const;

export const TYPE_CONFIRMATION_BUTTON_COLORS = {
    AMBER: 'amber',
    BLUE: 'blue',
    CYAN: 'cyan',
    EMERALD: 'emerald',
    FUCHSIA: 'fuchsia',
    GREEN: 'green',
    GRAY: 'gray',
    INDIGO: 'indigo',
    LIME: 'lime',
    ORANGE: 'orange',
    PINK: 'pink',
    PURPLE: 'purple',
    RED: 'red',
    ROSE: 'rose',
    SKY: 'sky',
    TEAL: 'teal',
    VIOLET: 'violet',
    YELLOW: 'yellow',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    DANGER: 'danger',
    WHITE: 'white',
} as const;
